import { render, staticRenderFns } from "./RemolqueExport.vue?vue&type=template&id=ed19ea68"
import script from "./RemolqueExport.vue?vue&type=script&lang=js"
export * from "./RemolqueExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports